/**
 * Silence a known-benign post-detection noise from ZXing on some phones.
 *
 * Chrome on Android (and the Emergent Preview wrapper) sometimes fires one
 * more frame after we've stopped the camera stream — the stopped track then
 * throws "The associated Track is in an invalid state". It never reaches
 * production users as a real problem (the scan already succeeded by then),
 * but it does trip the uncaught-error overlay. We swallow it quietly.
 */
const SIGNATURES = [
  "The associated Track is in an invalid state",
  "InvalidStateError: Track",
];

const isCameraNoise = (val) => {
  if (!val) return false;
  const msg = (val.message || val.reason?.message || String(val.reason || val) || "").toString();
  return SIGNATURES.some((s) => msg.includes(s));
};

if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      if (isCameraNoise(e.error || e)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true,
  );
  window.addEventListener(
    "unhandledrejection",
    (e) => {
      if (isCameraNoise(e.reason || e)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true,
  );
}

export {};
